import { Provider, Type } from '@angular/core';
import { UserProfileDialogService } from '../services/user-profile-dialog.service';

export const provideUserProfileDialog = <T extends UserProfileDialogService>(
    implementation: Type<T>,
): Provider => ({
    provide: UserProfileDialogService,
    useClass: implementation,
});
